import { defineMessages } from "react-intl";

const messages = defineMessages({
    text: {
        id: "cookie.text",
    },
    okay: {
        id: "cookie.okay",
    },
});

export default messages;
